import angular from 'angular';
import template from './template.html';
import './style.scss';
import './candidate-link-profile';
import MessageFormatter from '../../../service/message-formatter';
import { EDIT_STATE, VIEW_STATE } from '../../../summernote-options';

export const isTalenyaExtensionInstalled = () => window.TE && window.TE.sendMessage;

export const STATUS_SENT = 'STATUS_SENT';
export const STATUS_FAIL = 'STATUS_FAIL';
export const STATUS_SKIP = 'STATUS_SKIP';

export class SelectMessageTemplate {
    sendButtonDisabled = false;

    templateOptions = [];

    selectedTemplate = {};

    selectedTemplateIndex = 0;

    currentCandidate = {};

    currentCandidateIndex = 0;

    currentMessage = '';

    showLinkedinIcon = isTalenyaExtensionInstalled();

    messageTextareaEditState = VIEW_STATE;

    /* @ngInject */
    constructor($scope, RouteService, $timeout, ModalDialogService) {
        this.RouteService = RouteService;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ModalDialogService = ModalDialogService;
    }

    $onChanges() {
        const { templates } = this;

        if (templates) {
            const templateOptions = this.getMessageTemplateOptions(templates);

            this.$timeout(() => {
                this.templateOptions = templateOptions;
                this.onTemplateChanged(templateOptions[this.selectedTemplateIndex]);
            });
        }
        this.currentCandidate = this.getCurrentCandidate();
    }

    getCurrentCandidate() {
        return (this.candidates || [])[this.currentCandidateIndex];
    }

    getMessageTemplateOptions(messageTemplate) {
        return messageTemplate.map((template, index) => ({
            label: template.name,
            value: index,
            template,
        }));
    }

    onTemplateChanged({ template, value: index }) {
        if (this.messageTextareaEditState === EDIT_STATE) {
            this.showMessageOverrideConfirmationAlert(() => {
                this.selectedTemplate = template;
                this.selectedTemplateIndex = index;
                this.mapMessageToTokens();
                this.mapMessageToSpans();
                this.messageTextareaEditState = VIEW_STATE;
            });
        } else {
            this.selectedTemplate = template;
            this.selectedTemplateIndex = index;
            this.mapMessageToTokens();
            this.mapMessageToSpans();
            this.messageTextareaEditState = VIEW_STATE;
        }
    }

    onTemplateMessageChanged(template) {
        this.selectedTemplate = {
            ...this.selectedTemplate,
            template,
        };
    }

    onMessageChanged(message) {
        this.currentMessage = message;
    }

    skip() {
        this.onSkip();
        this.messageTextareaEditState = VIEW_STATE;
        this.openNextCandidateOrFinish();
    }

    send() {
        this.sendButtonDisabled = true;

        this.onSend({
            message: this.currentMessage,
            candidate: this.currentCandidate,
            selectedMessage: this.selectedTemplate,
        }).then(() => this.$timeout(() => this.sendButtonDisabled = false));

        this.openNextCandidateOrFinish();
    }

    openNextCandidateOrFinish() {
        const isLastCandidate = this.currentCandidateIndex + 1 === this.candidates.length;

        if (isLastCandidate) {
            this.onDone();
        } else {
            this.openNextCandidate();
        }
    }

    openNextCandidate() {
        this.currentCandidateIndex++;
        const currentCandidate = this.getCurrentCandidate();

        this.$timeout(() => {
            this.currentCandidate = currentCandidate;
            this.currentMessage = MessageFormatter.mapSpanToToken(this.selectedTemplate.template);
            this.mapMessageToSpans();
        });
    }

    onEditStateChanged(state) {
        if (state !== this.messageTextareaEditState) {
            this.messageTextareaEditState = state;

            if (state === EDIT_STATE) {
                this.mapMessageToTokens();
            } else if (state === VIEW_STATE) {
                this.mapMessageToSpans();
            }
        }
    }

    mapMessageToTokens() {
        this.currentMessage = MessageFormatter.mapSpanToToken(this.selectedTemplate.template);
    }

    mapMessageToSpans() {
        const messageWithSpans = MessageFormatter.mapTokenToSpan(this.currentMessage);

        if (messageWithSpans) {
            const { currentCandidate: candidate, recruiter, position } = this;
            const { template } = MessageFormatter.fillTemplate({ template: messageWithSpans }, candidate, recruiter, position);

            this.currentMessage = template;
            this.selectedTemplate = {
                ...this.selectedTemplate,
                template: messageWithSpans,
            };
        }
    }

    showMessageOverrideConfirmationAlert(onConfirm) {
        this.ModalDialogService.showDialog({
            modalDialogId: 'BatchTemplateOverrideAlert',
            title: 'MESSAGE_OVERWIRTE_ALERT_HEADER',
            body: 'MESSAGE_OVERWIRTE_ALERT',
            showCancelButton: true,
            showCloseButton: false,
            customZIndex: 2000,
            onClose: () => {
            },
            buttons: [
                {
                    label: 'MESSAGE_OVERWIRTE_ALERT_YES',
                    className: 'primary-button',
                    onClick: () => onConfirm(),
                },
            ],
        });
    }
}

export const selectMessageTemplateConfiguration = {
    template,
    bindings: {
        candidates: '<',
        recruiter: '<',
        position: '<',
        templates: '<',
        onSend: '&',
        onSkip: '&',
        onClose: '&',
        onDone: '&',
    },
    controller: SelectMessageTemplate,
    controllerAs: 'selectMessageTemplateCtrl',
};

angular.module('TALENYA-FE')
    .component('selectMessageTemplate', selectMessageTemplateConfiguration);
